export default "/github-mark-white.fab00c2d-bd36aa.svg";